import React from 'react'
import '../../assets/styles/productDetailCard.css'

const ProductDetailCard = (product) => {



  console.log("ProductDetailCard - product prop:", product);

    const relatedItems = [];

  // Category
  if (product?.category) {
    relatedItems.push({
      id: "cat-1",
      type: "Category",
      title:
        typeof product.category === "object"
          ? product.category.title 
          : product.category,
    });
  } 


  if (product?.macroFamily) {
    const macroFamilies = Array.isArray(product.macroFamily)
      ? product.macroFamily
      : [product.macroFamily];
    macroFamilies.forEach((mf, idx) => {
      relatedItems.push({
        id: `mf-${idx}`,
        type: "Macro Family",
        title: typeof mf === "object" ? mf.title || mf.name : mf,
      });
    });
  }

  // Industry
  if (product?.industry) {
    const industries = Array.isArray(product.industry)
      ? product.industry
      : [product.industry];
    industries.forEach((ind, idx) => {
      relatedItems.push({
        id: `ind-${idx}`,
        type: "Industry",
        title: typeof ind === "object" ? ind.title || ind.name : ind,
      });
    });
  } else {
    relatedItems.push({
      id: "ind-demo",
      type: "Industry",
      title: "Mining"
    });
  }

// console.log("product", product);

  // Tags
  if (product?.tags) {
    const tagsList = Array.isArray(product.tags)
      ? product.tags
      : [product.tags];
    const tagOptions = product.tagOptions || [];
    tagsList.forEach((tag, idx) => {
      let tagTitle = "";
      if (typeof tag === "object" && tag.name) {
        tagTitle = tag.name;
      } else if (typeof tag === "string") {
        // Try to find tag name from tagOptions
        const found = tagOptions.find(opt => opt._id === tag);
        tagTitle = found ? found.name : tag;
      } else {
        tagTitle = String(tag);
      }
      relatedItems.push({
        id: `tag-${idx}`,
        type: "Tag",
        title: tagTitle,
      });
    });
  }


  console.log("taglisst", relatedItems);
  return (
    <>
    <ul className="cards-sect">
              {relatedItems.map((item) => (
                <li className="cards__items" key={item.id}>
                  <div className="card-menu">
                    
                    <div className="card__contents">
                        <span className="card__types">
                          {item.type}
                        </span>
                        <h5>
                          {item.title}
                        </h5>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
    </>
  )
}

export default ProductDetailCard